var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToFolderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67981 2.0095L7.67968 2.00957L7.68656 2.02141C7.77458 2.17297 7.92057 2.40941 8.21109 2.53375C8.42768 2.62646 8.67344 2.62561 8.82931 2.62508C8.8406 2.62504 8.85141 2.625 8.8617 2.625H14.3299C15.0822 2.625 15.6982 3.24503 15.6982 3.9954V12.0046C15.6982 12.7599 15.082 13.375 14.3164 13.375H2.33009C1.56841 13.375 0.948242 12.7528 0.948242 11.9975V2.00247C0.948242 1.23867 1.55824 0.625 2.3284 0.625H5.63093C6.21845 0.625 6.57141 0.731851 6.82629 0.896893C7.08753 1.06605 7.31833 1.34277 7.5765 1.82221L7.57647 1.82223L7.57958 1.82788L7.67981 2.0095Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToFolderIcon);
export default __webpack_public_path__ + "static/media/add-to-folder-icon.a0c406ebf5ea8aa2a1413b462d8e024d.svg";
export { ForwardRef as ReactComponent };